import { Controller } from "@hotwired/stimulus"
import { toastStack, showToast } from "../lib/toasts.mjs"

// Gallery only. Action outcomes are simulated by an admin-only Turbo endpoint.
export default class extends Controller {
  show(event) {
    const name = event.currentTarget.dataset.toastExample
    const template = this.element.querySelector(`template[data-toast-example="${name}"]`)
    if (!template) return
    const toast = template.content.firstElementChild.cloneNode(true)
    if (toast.id) document.getElementById(toast.id)?.remove()
    toastStack().prepend(toast)
  }

  burst() {
    for (let index = 1; index <= 4; index++) showToast(`Change ${index} saved`)
  }
}
